import { render, staticRenderFns } from "./com_attachment_list.vue?vue&type=template&id=d7511cdc"
import script from "./com_attachment_list.vue?vue&type=script&lang=js"
export * from "./com_attachment_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports